var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['dragger', { 'is-draggable': _vm.isDraggable, 'is-dragging': _vm.isDragging }],on:{"mouseenter":_vm.init,"mousedown":_vm.start,"wheel":_vm.scroll}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }